var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8A1.5 1.5 0 0 1 13 9.5v.5c0 1.971-1.86 4-5 4-3.14 0-5-2.029-5-4v-.5A1.5 1.5 0 0 1 4.5 8h7ZM8 1.5A2.75 2.75 0 1 1 8 7a2.75 2.75 0 0 1 0-5.5Z",
    fill: "currentColor"
  })));
};

export { SvgPerson as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMS41IDhDMTIuMzI4NCA4IDEzIDguNjcxNTcgMTMgOS41VjEwQzEzIDExLjk3MTQgMTEuMTQwNSAxNCA4IDE0QzQuODU5NTEgMTQgMyAxMS45NzE0IDMgMTBWOS41QzMgOC42NzE1NyAzLjY3MTU3IDggNC41IDhIMTEuNVpNOCAxLjVDOS41MTg3OCAxLjUgMTAuNzUgMi43MzEyMiAxMC43NSA0LjI1QzEwLjc1IDUuNzY4NzggOS41MTg3OCA3IDggN0M2LjQ4MTIyIDcgNS4yNSA1Ljc2ODc4IDUuMjUgNC4yNUM1LjI1IDIuNzMxMjIgNi40ODEyMiAxLjUgOCAxLjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";